const API_BASE_URL = '/inventory-search';

export const RESUME_SEARCH_SAVED_SEARCHES_PREFERENCES_KEY = 'resume';

export const ENDPOINTS = {
  CertificationsDescriptions: `${API_BASE_URL}/resumes/certifications/descriptions`,
  CertificationsIssuingOrganizations: `${API_BASE_URL}/resumes/certifications/issuing-organizations`,
  EducationsDegrees: `${API_BASE_URL}/resumes/educations/degrees`,
  EducationsIssuingOrganizations: `${API_BASE_URL}/resumes/educations/issuing-organizations`,
  EducationsMajors: `${API_BASE_URL}/resumes/educations/majors`,
  Industries: `${API_BASE_URL}/resumes/industries`,
  Languages: `${API_BASE_URL}/resumes/languages`,
  LocationsCities: `${API_BASE_URL}/resumes/locations/cities`,
  LocationsStates: `${API_BASE_URL}/resumes/locations/states`,
  OpenToRelocation: `${API_BASE_URL}/datasheets/open-to-relocation`,
  ProfessionalAssociationsDescriptions: `${API_BASE_URL}/resumes/professional-associations/descriptions`,
  ProfessionalAssociationsIssuingOrganizations: `${API_BASE_URL}/resumes/professional-associations/issuing-organizations`,
  ProfessionalExperiencesCompanies: `${API_BASE_URL}/resumes/professional-experiences/companies`,
  ProfessionalExperiencesTitles: `${API_BASE_URL}/resumes/professional-experiences/titles`,
  ReasonsForLooking: `${API_BASE_URL}/datasheets/reasons-for-looking`,
  Resumes: `${API_BASE_URL}/resumes`,
  Skills: `${API_BASE_URL}/resumes/skills`,
  Specialties: `${API_BASE_URL}/resumes/specialties`,
  Statuses: `${API_BASE_URL}/datasheets/statuses`,
  Subspecialties: `${API_BASE_URL}/resumes/subspecialties`,
  TimesToStart: `${API_BASE_URL}/datasheets/times-to-start`,
  Types: `${API_BASE_URL}/datasheets/types`,
  WorkPreferences: `${API_BASE_URL}/datasheets/work-preferences`
};

export const SLOT_PROPS = {
  collapsiblePanel: {
    contentStyles: { overflowY: 'auto' }
  }
};
